module.exports = __webpack_public_path__ + "img/price.0f0897cf.svg";